<template>
  <div class="basketcomponent">
    <div v-if="errors[0]" class="bg-red-lightest border border-red-light text-red-dark px-4 my-2 py-3 rounded relative" role="alert">
      <strong class="font-bold">Oh no!</strong>
      <span class="block sm:inline" v-for="error in errors" :key="error">{{ error }}</span>
    </div>

    <router-link tag="button" :to="{ name: 'Shop', params: { 'hostUrl': hostUrl } }" v-if="viewtype == 'orderform' || viewtype == 'generator'" class="bg-green-heinz hover:bg-green-heinz-light text-black py-4 px-2 w-full rounded-t-lg mt-1">zurück zur Speisekarte</router-link>
    <hr v-if="viewtype == 'orderform' || viewtype == 'generator'" class="p-0 m-0 border-t-2 border-grey-light" />
    <router-link tag="button" :to="{ name: 'Warenkorb', params: { 'hostUrl': hostUrl } }" v-if="!emptyBasket && viewtype != 'orderform'" class="bg-green-heinz hover:bg-green-heinz-light text-black font-bold py-4 px-2 w-full" :class="{ 'rounded-t-lg': viewtype == 'menu' }">zum Warenkorb!</router-link>

    <div v-if="emptyBasket" class="bg-green-heinz border-t-4 border-green-dark rounded-b text-black px-4 py-3 shadow-md" role="alert">
      <div class="flex">
        <div class="py-1"><svg class="fill-current h-6 w-6 text-black mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>
        <div>
          <p class="font-bold">Hungriger Warenkorb</p>
          <p class="text-sm">Es befinden sich noch keine Artikel in deinem Warenkorb. Wie traurig!</p>
        </div>
      </div>
    </div>
    <table class="products" v-if="!emptyBasket">
      <thead>
        <tr>
          <th colspan="2" class="productlabel w-full clearfix bottomborder-green align-bottom p-2">
            <h2 class="float-left m-0 p-0 border-b-0">{{ title }} ({{ basketSize }})</h2>
            <button v-if="!officeClient && !hasTable" v-on:click="addcoupon()" class="float-right text-sm text-black py-1 px-2 my-1 rounded" :class="{ 'bg-grey-light hover:bg-grey cursor-not-allowed': getBasket.currenthost.item_allow_coupons === 'N', 'bg-green-heinz hover:bg-green-heinz-light': getBasket.currenthost.item_allow_coupons === 'Y' }">Gutschein einlösen</button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="basketItem in getBasket.basket" :key="basketItem.id" class="product">
          <td class="productlabel p-2 align-top">
            <div class="title">{{ basketItem.productdata.item_title }} ({{ basketItem.humanSize }})</div>
            <div class="content">{{ basketItem.productdata.item_content }}</div>
            <div class="ingredients">
              <div>{{ basketItem.productdata.item_ingredients_list }}</div>
              <div v-for="addon in basketItem.basketaddons" :key="addon.title" :class="{ 'text-green-darker': addon.count > 0, 'text-red-darker': addon.count <= 0 }">
                <template v-if="!(addon.count == 0 && addon.included == 0)">
                  <span v-if="addon.count > 0">✅ mit</span>
                  <span v-if="addon.count <= 0">⭕️ ohne</span>
                  <span v-if="addon.count == 2">doppelt</span>
                  <span v-if="addon.count == 3">dreifach</span>
                  {{ addon.title }}
                </template>
                <span v-if="addon.count > addon.included && addon.price > 0">{{ addon.price | pricetag }}</span>
              </div>
            </div>
            <div>
              <div v-if="basketItem.item_multiuser != ''"><small class="text-green-heinz">Bestellt von {{ basketItem.item_multiuser }}</small></div>
              <div v-if="basketItem.item_note != ''">
                <small><strong>Hinweise:</strong> {{ basketItem.item_note }}</small>
              </div>
              <router-link v-if="basketItem.productdata.item_ingredients" exact tag="button" :to="{ name: 'Generator', params: { hostUrl: hostUrl, id: basketItem.id } }" class="bg-green-heinz hover:bg-green-heinz-light text-sm text-black py-1 px-2 my-1 rounded" class-active="active">Zutaten ändern</router-link>
              <button v-if="basketItem.productdata.item_type !== 'couponcode'" v-on:click="addnote(basketItem.id, $event)" class="bg-green-heinz hover:bg-green-heinz-light text-sm text-black py-1 px-2 my-1 rounded">Hinweis <span v-if="basketItem.item_note == ''">hinzufügen</span><span v-if="basketItem.item_note != ''">bearbeiten</span></button>
              <button v-if="basketItem.item_has_ai_ingredients" v-on:click="removeAiIngredients(basketItem.id)" class="bg-green-heinz hover:bg-green-heinz-light text-sm text-black py-1 px-2 my-1 rounded">Erkannte Zutaten entfernen</button>
              <button v-on:click="cloneProduct(basketItem.id, $event)" class="bg-green-heinz hover:bg-green-heinz-light text-sm text-black py-1 px-2 my-1 rounded">Artikel klonen</button>
              <button v-if="basketItem.item_customerproduct_allowed" v-on:click="saveCustomerProduct(basketItem.id, $event)" class="bg-green-heinz hover:bg-green-heinz-light text-sm text-black py-1 px-2 my-1 rounded">als Eigenkreation speichern</button>
              <button v-if="basketItem.item_customerproduct_delete_allowed" v-on:click="deleteCustomerProduct(basketItem.item_customerproduct, $event)" class="bg-green-heinz hover:bg-green-heinz-light text-sm text-black py-1 px-2 my-1 rounded">Eigenkreation löschen</button>
              <button v-on:click="removeProductFromBasket(basketItem.id, $event)" class="bg-green-heinz hover:bg-green-heinz-light text-sm text-black py-1 px-2 my-1 rounded">Artikel löschen</button>
            </div>
          </td>
          <td class="price w-8 text-right align-top p-2">
            {{ basketItem.price | pricetag }}
          </td>
        </tr>
        <tr v-if="!officeClient && mbwDeviation && item_homedelivery" class="product">
          <td class="productlabel p-2 align-top">
            <div class="title">Differenz zum Mindestbestellwert</div>
            <div class="content">Der Mindestbestellwert beträgt <nobr>{{ getBasket.shipping.mbw | pricetag }}</nobr></div>
          </td>
          <td class="price w-8 text-right align-top p-2">
            <span>{{ (mbwDeviation) | pricetag }}</span>
          </td>
        </tr>
        <tr v-if="!officeClient && getBasket.shipping && getBasket.currenthost && getBasket.currenthost.item_homedelivery == 'Y' && item_homedelivery" class="product">
          <td class="productlabel p-2 align-top">
            <div class="title">Lieferkosten</div>
            <div class="content">
              von {{ getBasket.currenthost.item_ort }}
              nach {{ getBasket.shipping.destination }}
              <span v-if="!getBasket.shipping.destination">Unbekannt</span>
            </div>
          </td>
          <td class="price w-8 text-right align-top p-2">
            <span v-if="!getBasket.shipping.destination">? €</span>
            <span v-if="getBasket.shipping.destination && getBasket.shipping.value > 0">{{ getBasket.shipping.value | pricetag }}</span>
            <span v-if="getBasket.shipping.destination && getBasket.shipping.value == 0">frei Haus!</span>
          </td>
        </tr>
        <tr v-if="option_bookatable" class="product">
          <td class="productlabel p-2 align-top">
            <div class="title">Tischreservierung</div>
            <div class="content">
              Du bekommst deine Bestellung im Restaurant frisch auf den Tisch 🔥
            </div>
          </td>
          <td class="price w-8 text-right align-top p-2">
            <span>kostenlos!</span>
          </td>
        </tr>
        <tr v-if="getBasket.coupon && getBasket.coupon.success" class="product">
          <td class="productlabel p-2 align-top">
            <div class="title">Gutscheincode</div>
            <div class="content">
              <span v-html="getBasket.coupon.message"></span><br />
              <span v-if="getBasket.coupon.item_discount_left">Noch {{ getBasket.coupon.item_discount_left | pricetag }} von {{ getBasket.coupon.item_discount_value | pricetag }} verfügbar</span>
            </div>
          </td>
          <td class="price w-8 text-right align-top p-2">
            <span>{{ (getBasket.coupon.item_discount * -1) | pricetag }}</span>
          </td>
        </tr>
        <tr v-if="item_tip > 0" class="product">
          <td class="productlabel p-2 align-top">
            <div class="title">Trinkgeld</div>
          </td>
          <td class="price w-8 text-right align-top p-2">
            <span>{{ item_tip | pricetag }}</span>
          </td>
        </tr>
        <tr class="product">
          <td class="productlabel p-2 align-top">
            <div class="title">Gesamt</div>
            <div class="content"></div>
          </td>
          <td class="price w-8 text-right align-top p-2 font-bold">
            {{ orderSum | pricetag }}
          </td>
        </tr>
        <tr v-if="typeof getBasket.currenthost != 'undefined' && getBasket.currenthost.item_webpayment_free == 'N' && item_payment != 'nachnahme'" class="product">
          <td class="productlabel p-2 align-top">
            <div class="title">Gebühr für Onlinezahlung</div>
            <div class="content">Zahlung mit <span class="paymenttype">{{ item_payment }}</span></div>
          </td>
          <td class="price w-8 text-right align-top p-2">
            <span>+ {{ .5 | pricetag }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="hasOfficeOrder && isOfficeOrderMaster" class="border-green-heinz border-3 border-b-0 p-2" :class="{'border-b-3 border-t-0 rounded-b-lg': viewtype === 'orderform' || emptyBasket }">
      <strong>Aktive Mitbesteller ({{ activeOfficeOrderClients.length }}/{{ totalOfficeOrderClients }})</strong><br />
      <ul>
        <li v-for="officeOrderClient in officeOrderClients" :key="officeOrderClient.name">
          <strong>{{ officeOrderClient.name }}</strong>
          → <span :class="officeOrderClient.statusClass">{{ officeOrderClient.status }}</span>
        </li>
      </ul>
    </div>
    <router-link tag="button" :to="{ name: 'Warenkorb', params: { 'hostUrl': hostUrl } }" v-if="!emptyBasket && (viewtype == 'menu' || viewtype == 'generator')" class="bg-green-heinz hover:bg-green-heinz text-black font-bold py-4 px-2 w-full rounded-b-lg">zum Warenkorb!</router-link>
  </div>
</template>

<script>
import endpoints from '../endpoints'
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import Pusher from 'pusher-js/with-encryption'

export default {
  name: 'Basketcomponent',
  props: ['viewtype'],

  data () {
    return {
      title: 'Warenkorb',
      hostUrl: this.$route.params.hostUrl,
      errors: [],
      activePusher: false,
      pusher: null
    }
  },

  computed: {
    ...mapGetters([
      'getBasket',
      'emptyBasket',
      'basketSize',
      'productSum',
      'basketSum',
      'basketSumWoMbw',
      'shippingCosts',
      'mbwDeviation',
      'hasOfficeOrder',
      'isOfficeOrderMaster',
      'isOfficeOrderClient',
      'officeOrderClients',
      'officeOrder',
      'hasTable'
    ]),

    ...mapFields([
      'content.item_payment',
      'content.item_homedelivery',
      'content.option_bookatable',
      'content.item_tip',
      'officeMaster'
    ]),

    officeClient () {
      return this.hasOfficeOrder && this.isOfficeOrderClient
    },

    orderSum () {
      const tipVal = parseFloat(this.item_tip)
      const tip = this.officeClient || isNaN(tipVal) ? 0 : tipVal

      if (this.item_homedelivery && !this.officeClient) {
        return (this.basketSum + this.shippingCosts + tip)
      } else {
        return this.basketSumWoMbw + tip
      }
    },

    activeOfficeOrderClients () {
      if (!this.officeOrderClients) return []

      return Object.values(this.officeOrderClients).filter((item) => {
        return item.statusActive
      })
    },

    totalOfficeOrderClients () {
      if (!this.officeOrderClients) return 0
      return this.officeOrderClients.length
    }
  },

  created () {
    this.updateBasket()
    this.watchOfficeOrderMaster()
  },

  mounted () {
    document.getElementsByTagName('body')[0].classList.add('has-basket')
  },

  beforeDestroy () {
    document.getElementsByTagName('body')[0].classList.remove('has-basket')
  },

  watch: {
    isOfficeOrderMaster: function (val) {
      this.$nextTick(() => {
        this.watchOfficeOrderMaster()
      })
    }
  },

  methods: {
    ...mapActions([
      'updateBasket',
      'watchOfficeOrder',
      'removeProduct',
      'loadMenu'
    ]),

    cloneProduct (basketId, event) {
      event.target.classList.add('loading')

      axios.post(endpoints.cloneProduct, {
        'basketId': Number(basketId)
      })
        .then(response => {
          this.updateBasket()
          event.target.classList.remove('loading')
        })
        .catch(e => {
          this.errors.push('Der gewählte Artikel konnte nicht geklont werden 😭')
        })
    },

    saveCustomerProduct (basketId, event) {
      event.target.classList.add('loading')

      axios.post(endpoints.saveCustomerProduct, {
        'basketId': Number(basketId)
      })
        .then(response => {
          this.updateBasket()
          this.loadMenu({
            hostId: this.getBasket.currenthost.id,
            callback: () => {
              window.eventBus.$emit('renderMenu')
              event.target.classList.remove('loading')
            },
            forceReload: true
          })
        })
        .catch(e => {
          event.target.classList.remove('loading')
          this.errors.push('Der gewählte Artikel konnte nicht als Eigenkreation gespeichert werden 😭')
        })
    },

    deleteCustomerProduct (productId, event) {
      event.target.classList.add('loading')

      axios.post(endpoints.deleteCustomerProduct, {
        'productId': Number(productId)
      })
        .then(response => {
          this.updateBasket()
          event.target.classList.remove('loading')
          this.loadMenu({
            hostId: this.getBasket.currenthost.id,
            callback: () => {
              window.eventBus.$emit('renderMenu')
              event.target.classList.remove('loading')
            },
            forceReload: true
          })
        })
        .catch(e => {
          console.log(e)
          this.errors.push('Der gewählte Artikel konnte nicht aus den Eigenkreationen gelöscht werden 😭')
        })
    },

    /**
     * Remove a product from the basket through vuex action
     * @param {string|number} basketId the Id of the product to remove
     * @param {Event} event the click event
     */
    removeProductFromBasket (basketId, event) {
      event.target.classList.add('loading')

      this.removeProduct({ basketId: Number(basketId) })
        .catch(() => {
          this.errors.push('Der gewählte Artikel konnte nicht entfernt werden 😭')
        })
        .finally(() => {
          event.target.classList.remove('loading')

          if (this.$router.currentRoute.name === 'Generator') {
            if (this.$router.currentRoute.params.id === basketId) {
              this.$router.go(-1)
            }
          }
        })
    },

    addcoupon () {
      window.eventBus.$emit('addCoupon')
    },

    addnote (basketId) {
      window.eventBus.$emit('addNote', {
        basketId: basketId,
        note: this.getBasket.basket[basketId].item_note
      })
    },

    watchOfficeOrderMaster () {
      if (this.isOfficeOrderMaster) {
        this.activePusher = true

        this.pusher = new Pusher('4a6b5ab010ed93259f35', {
          cluster: 'eu',
          authEndpoint: endpoints.pusherAuth
        })

        const channel = this.pusher.subscribe('private-officeorder-' + this.officeOrder.officeOrderId)
        channel.bind('update', (data) => {
          this.updateBasket()
          this.watchOfficeOrder()
        })
      } else {
        if (this.activePusher) {
          this.activePusher = false
          this.pusher.disconnect()
        }
      }
    },

    removeAiIngredients (basketId) {
      axios.post(endpoints.removeAiIngredients, {
        basketId: basketId
      })
      .then(response => {
        this.updateBasket()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Basketcomponent.vue